<template>
  <VisionIcon
    icon="plus"
    colour="contrast"
    size="x-small"
    :class="$b({ expanded, size })"
  />
</template>

<script>
export default {
  name: 'ExpandButton',

  props: {
    expanded: { type: Boolean, required: true },
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'medium',
          'small',
          'xs'
        ].includes(value)
      }
    }
  }
}
</script>

<style lang="postcss">
.ExpandButton {
  @apply rotate-0 transition-all duration-300 ease-in-out;

  &--expanded {
    @apply rotate-45 scale-125;
  }

  &--size-small {
    @apply text-xs;
  }
}
</style>
